import React from 'react';
import { Link, useParams } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { blogPostingSchema, breadcrumbSchema } from '../constants/structuredData';
import blogPosts from '../content/blogPosts.json';
import NotFound from './NotFound';
import './Page.css';

function isHeadingLine(line) {
  const text = line.trim();
  if (text.length >= 100 || text.includes(':')) return false;
  return Boolean(
    text.match(/^[A-Z][a-z\s]+$/) || text.match(/^\d+\.\s+[A-Z]/) || text.match(/^[A-Z][^.!?]*$/)
  );
}

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);
  if (!post) return <NotFound />;

  const path = `/blog/${post.slug}`;
  const related = blogPosts.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <div className="page">
      <SeoHead
        title={`${post.metaTitle} | Unaffected Healthcare`}
        description={post.description}
        keywords={post.keywords}
        path={path}
        image={post.image}
        type="article"
        jsonLd={[
          blogPostingSchema(post),
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: post.title, path },
          ]),
        ]}
      />

      <section className="page-content">
        <div className="container">
          <nav aria-label="Breadcrumb" className="blog-post-meta" style={{ marginBottom: 16 }}>
            <Link to="/">Home</Link>
            <span aria-hidden="true">/</span>
            <Link to="/blog">Blog</Link>
          </nav>

          <article className="blog-post-full">
            <div className="blog-post-header">
              <div className="blog-post-image-full">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="blog-post-header-content">
                <div className="blog-post-meta">
                  <span className="blog-post-category">{post.category}</span>
                  <time className="blog-post-date" dateTime={post.datePublished}>
                    {post.datePublished.slice(0, 4)}
                  </time>
                </div>
                <h1 className="blog-post-title-full">{post.title}</h1>
                <p className="blog-post-excerpt-full">{post.excerpt}</p>
              </div>
            </div>

            <div className="blog-post-body expanded">
              <div className="blog-post-content-text">
                {post.content.split('\n').map((line, index) => {
                  if (!line.trim()) return null;
                  if (isHeadingLine(line)) {
                    return (
                      <h2 key={index} style={{ marginTop: '20px', marginBottom: '10px', fontWeight: 'bold', fontSize: '1.15rem' }}>
                        {line}
                      </h2>
                    );
                  }
                  return <p key={index}>{line}</p>;
                })}
              </div>
            </div>

            <Link to="/blog" className="btn btn-primary" style={{ marginTop: '20px' }}>
              Back to blog
            </Link>
          </article>

          {related.length ? (
            <div className="content-section" style={{ marginTop: 32 }}>
              <h2 className="section-title">More articles</h2>
              <ul>
                {related.map((p) => (
                  <li key={p.slug}>
                    <Link to={`/blog/${p.slug}`}>{p.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
